





















import Vue from 'vue'

import {NavItem, NavBar, NavContainer} from '../../stores/NavBar'

import NavBarItem from './NavBarItem.vue'
import {Component, Inject, Prop} from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { RootStore } from '../../stores/RootStore'

import NavBarDrawer from './NavBarDrawer.vue'

@Observer
@Component({components: {NavBarItem, NavBarDrawer}})
export default class NavBarContainer extends Vue {
    @Inject()
    rootStore!: RootStore

    navBar!: NavBar

    @Prop()
    item!: NavContainer

    created() {
        this.navBar = this.rootStore.navBar
    }

    body() { 
        return document.body
    }

    get label(): string {
        return this.item!.label!.toUpperCase()
    }
}
